import { P2GBox, P2GGrid, P2GLink, P2GSticky, P2GText } from '@parcel2go/core-ui';
import P2GContentDropDown from '../../P2GContentDropDown';
import { DashDateSelection, GetPeriodDisplay } from '../../dash/DashDateSelection';
import CsvExport from './CsvExport';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  period: string;
  selected: string;
  setPeriod: (period: string) => void;
  children?: React.ReactNode;
}

const ListyFilterBarDesktop: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GSticky align="top" backgroundColor="transparent">
      <P2GBox pt={1} pb={1} sx={(t) => ({ backgroundColor: t.palette.grey.A100 })}>
        <P2GGrid container gap={2} alignItems="center" wrap="nowrap">
          {props.children && (
            <P2GGrid item flexShrink={1}>
              {props.children}
            </P2GGrid>
          )}
          <P2GGrid item flexGrow={1}></P2GGrid>
          <P2GGrid item flexShrink={1}>
            <P2GContentDropDown
              control={
                <P2GText classNames="p2g-previousorders-daterange">
                  <Trans
                    t={t}
                    i18nKey="MY_ORDERS_SHOWING_PERIOD"
                    defaults="Showing: <a>{{period}}</a>"
                    values={{ period: GetPeriodDisplay(props.period) }}
                    components={{ a: <P2GLink /> }}
                  />
                </P2GText>
              }
            >
              <div style={{ width: '300px' }}>
                <DashDateSelection period={props.period} setPeriod={props.setPeriod} />
              </div>
            </P2GContentDropDown>
          </P2GGrid>
          <P2GGrid item flexShrink={1}>
            <CsvExport period={props.period} selected={props.selected} />
          </P2GGrid>
        </P2GGrid>
      </P2GBox>
    </P2GSticky>
  );
};

export default ListyFilterBarDesktop;
